import React from 'react';
import {
  WarrantyInfo,
  MonthsRemaining,
  TextDivider,
  MilesRemaining,
  WarrantyDetailsHeader,
} from './CarvanaCareStatusInfo.styles';

export const CarvanaCareStatusInfo = ({ durationLeft, protectionMiles }: any) => (
  <WarrantyDetailsHeader>
    <WarrantyInfo data-testid="carvana-care-warranty-info">
      <MonthsRemaining data-testid="carvana-care-duration">{durationLeft}</MonthsRemaining>
      <TextDivider>|</TextDivider>
      <MilesRemaining data-testid="carvana-care-miles-remaining">
        up to {(protectionMiles || 0).toLocaleString()} miles
      </MilesRemaining>
    </WarrantyInfo>
  </WarrantyDetailsHeader>
);
